import { useWorkspaces } from "@/hooks/useWorkspaces";
import { VocService } from "@/services/voc/voc.service";

const pageSize = 10;

export const useUploadHistories = (page = 1) => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const { data, total, error, isLoading, mutate } = VocService.getUploadHistories(
    sessionCurrentWorkspaceId,
    (page - 1) * pageSize,
    pageSize,
  );

  const lastPage = total ? Math.ceil(total / pageSize) : undefined;

  return {
    uploadHistories: data,
    lastPage,
    total,
    pageSize,
    error,
    isLoading,
    mutate,
  };
};
